export default "__VITE_ASSET__DQ$qupor__"